import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(auth)/login/page.tsx");
